// Currently unused, but will be used to implement address verification dialog
(function() {
    'use strict';

    angular.module('app').controller('AddressValidationController', AddressValidationController);

    function AddressValidationController($scope, $modalInstance, $location, $anchorScroll, usps, order, shippingPackages, shippingObj,checkoutForm) {
        $scope.save = save;
        $scope.cancel = cancel;
        $scope.edit = edit;
        $scope.usps = usps;
        $scope.shippingPackages = shippingPackages;
        $scope.order = order;
        $scope.result = true;
        $scope.shippingObj = shippingObj;
        $scope.checkoutForm = checkoutForm;



        function save(info) {            

            if($scope.usps.uoptions === 'mine')
            {                
                $scope.order.shipping_address.line1 = $scope.shippingPackages.line1;
                $scope.order.shipping_address.city = $scope.shippingPackages.city;
                $scope.order.shipping_address.state = $scope.shippingPackages.state;
                $scope.order.shipping_address.postalCode = $scope.shippingPackages.postalCode;
                $scope.order.shipping_address.line2 = $scope.shippingPackages.line2;
                $modalInstance.close($scope.shippingPackage);
            }
            else if($scope.usps.uoptions === 'theirs')
            {
                $scope.order.shipping_address.line1 = $scope.usps.uaddress1;
                $scope.order.shipping_address.city = $scope.usps.ucity;
                $scope.order.shipping_address.state = $scope.usps.ustate;
                $scope.order.shipping_address.postalCode = $scope.usps.uzip1;
                $scope.order.shipping_address.line2 = $scope.usps.uaddress2;                
                $modalInstance.close($scope.usps);
            }

            var position = $(".step3").position();
            scroll(0,position.top+300);
            $scope.shippingObj.shippingModel = 1;

        }

        function cancel() {            
            $modalInstance.dismiss('cancel');
            $scope.shippingObj.shippingModel = 0;            
        }

        function edit()
        {            
            $modalInstance.close();
            $scope.shippingObj.shippingModel = 0;
            $scope.checkoutForm.shippingAddress.$dirty = false;
            $scope.checkoutForm.shippingCity.$dirty = false;
            $scope.checkoutForm.shippingState.$dirty = false;
            $scope.checkoutForm.shippingZip.$dirty = false;
            $scope.checkoutForm.shippingCountryInt.$dirty = false;
            $scope.checkoutForm.shippingAddress.$pristine = true;
            $scope.checkoutForm.shippingCity.$pristine = true;
            $scope.checkoutForm.shippingState.$pristine = true;
            $scope.checkoutForm.shippingZip.$pristine = true;
            $scope.checkoutForm.shippingCountryInt.$pristine = true;

            var position = $(".step2").position();
            scroll(0,position.top);
        }
    }
})();
